
import './blog.scss';

function importAll(r) {
  return r.keys().map(r);
}

const blog_img = importAll(require.context('./blog/', false, /\.(png|jpe?g|svg)$/));

import './logo/icon.svg';
import './logo/icon_white.svg';
import './logo/logo.svg';
import './logo/logo.png';
import './logo/logo_transparent_crop.png';

// FA icons
import { library, dom } from '@fortawesome/fontawesome-svg-core'
import { faFacebook, faTwitter } from '@fortawesome/free-brands-svg-icons'
import { faHome } from '@fortawesome/free-solid-svg-icons'


import Vue from 'vue';

// toggle menu
const menuApp = new Vue({
  el: '#navbar',
  delimiters: ['[[', ']]'],
  data: function () {
    return {
      isActive: false,
    }
  },
  methods: {
    toggleMenu: function() {
      this.isActive = !this.isActive;
    }
  },
  mounted: function () {
    library.add(
      faFacebook,
      faTwitter,
      faHome,
    )
    dom.watch()
  }
});

const cookieApp = new Vue({
  el: '#cookies',
  delimiters: ['[[', ']]'],
  data: function () {
    return {
      accepted: localStorage.getItem('cookies-accepted'),
    }
  },
  methods: {
    accept: function() {
      const now = new Date();
      this.accepted = true;
      localStorage.setItem('cookies-accepted', this.accepted);
      localStorage.setItem('cookies-accepted-date', now.toUTCString());
    }
  }
});
